import React from 'react'

export default function Throw({ className, ...props }) {
  return (
    <svg className={`${className} w-8 h-8`} viewBox="0 0 25 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path d="M12.5 12L22.5 7L17.5 17L12.5 12Z" stroke="#374151" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
    <path d="M12.5 12L2.5 2L7.5 22L12.5 12Z" stroke="#374151" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
    </svg>
  )
}
